import {FunctionalComponent, h} from 'preact';
import {makePollAnswerMsg} from "./InputUIService";
import {log} from "../libs/QuerloLogger";

export const MultipleChoice: FunctionalComponent<{
    question: any; answerCallback: (answerRawObj: any) => void;
}> = ({question, answerCallback}) => {

    function castAnswer(a: any): void {
        log.debug('Picked answer: ', a.txt);

        const pollAnswerMsg = makePollAnswerMsg({
            txt: a.txt_ext ? a.txt_ext : a.txt,
            ansID: a.choice_id
        }, question);

        answerCallback(pollAnswerMsg);
    }

    return <form name="inputForm"
          role="form"
          className="{invalidSubmitted: showErr()}">

        <fieldset>
            <legend>Answers</legend>
            <div>
                {question.answers.map(
                    (answerRawObj: any) => (
                        <button onClick={(e): void => {e.preventDefault(); castAnswer(answerRawObj)}}
                                aria-label={`choose option: ${answerRawObj.txt}`}>
                            {answerRawObj.txt}
                        </button>
                    )
                )}
            </div>
        </fieldset>
    </form>;
}
